import { Global } from '@sourceflow-uk/sourceflow-sdk';
import SeoHead from '../../../../components/SeoHead';
import MainBanner from '../../../../components/MainBanner';
import SimpleContent from '../../../../components/SimpleContent';

export default function ContractorsPageSubmissionSuccess({
    global,
}) {
    return (
        <>
            <SeoHead
                page_name={`Subscription Success | Science, Engineering & Life Science Recruitment, Jobs & Staffing | SRG | United States`}
                canonical_link={`podcasts/subscription-success`}
                robots="noindex, follow"
                en_gb={false}
                en_us={true}
            />
            <MainBanner
                global={global}
                pathPrefix={`podcasts.subscriptions_success.main_banner`}
                customClass={``}
                content={
                    <>
                        <h1>Subscription Success</h1>
                    </>
                }
                imageURL1={`/site-assets/images/main-banner.jpg`}
                imageALT1={`Main Banner`}
                imageURL2={`/site-assets/images/main-banner-overlay.jpg`}
                imageALT2={`Overlay Main Banner`}
                displayImage1={false}
            />
            <SimpleContent
                global={global}
                pathPrefix={`podcasts.subscriptions_success.simple_content`}
                customClass={`py-5 text-center`}
                content={
                    <>
                        <p>You've subscribed to our newsletter!</p>
                        <p>We will be in touch shortly!</p>
                    </>}
                editableText={true}
                buttonTitle1={`Back to jobs`}
                buttonTitleLink1={`/jobs/`}
                buttonTitle2={`Business solutions`}
                buttonTitleLink2={`/us/business-solutions/`}
            />
        </>
    )
}

export async function getStaticProps({ params }) {
    const global = (await Global()).toJson();

    return {
        props: {
            global,
        }
    };
}
